import {
  ListItem,
  Box,
  AHIcon,
  AHText,
  EmployeeAvatar,
  useLayoutContext,
} from "arkh";
import { FormattedMessage } from "react-intl";
import { graphql, useFragment } from "react-relay";
import { EmployeeRoleEditEmployeesListItem_employee$key } from "./__generated__/EmployeeRoleEditEmployeesListItem_employee.graphql";
import { EmployeeRoleEditEmployeesListItem_query$key } from "./__generated__/EmployeeRoleEditEmployeesListItem_query.graphql";

function EmployeeItem(props: {
  employee: EmployeeRoleEditEmployeesListItem_employee$key;
}) {
  const employee = useFragment(
    graphql`
      fragment EmployeeRoleEditEmployeesListItem_employee on Employee {
        ...Avatar_employee
        name
      }
    `,
    props.employee
  );
  return (
    <Box style={{ flexDirection: "row", alignItems: "center" }} space="xsmall">
      <EmployeeAvatar employee={employee} size="small" />
      <AHText type="body" spaceLeft="xsmall" numberOfLines={1}>
        {employee.name}
      </AHText>
    </Box>
  );
}

export function EmployeeRoleEditEmployeesListItem(props: {
  data: EmployeeRoleEditEmployeesListItem_query$key;
  openEmployeesSelector: () => void;
}) {
  const layout = useLayoutContext();
  const data = useFragment(
    graphql`
      fragment EmployeeRoleEditEmployeesListItem_query on Query {
        employeesByIds(ids: $employeeIds) {
          id
          ...EmployeeRoleEditEmployeesListItem_employee
        }
      }
    `,
    props.data
  );
  const employees = data.employeesByIds?.filter((e) => e !== null) ?? [];
  return (
    <ListItem
      border="border-primary"
      isLast
      onPress={() => {
        props.openEmployeesSelector();
      }}
      right={
        <Box style={{ flexDirection: "row", alignItems: "center" }}>
          {employees.length === 1 ? (
            <EmployeeItem employee={employees[0]} />
          ) : null}
          <ListItem.NavArrow />
        </Box>
      }
      left={<AHIcon type="user" color="text-secondary" />}
      footer={
        employees.length > 1 ? (
          <Box
            style={{
              flexDirection: "row",
              alignItems: "center",
              flexWrap: "wrap",
              margin: -layout.space.xsmall,
            }}
          >
            {employees.map((employee) => (
              <EmployeeItem key={employee.id} employee={employee} />
            ))}
          </Box>
        ) : null
      }
    >
      <ListItem.Title color="text-secondary">
        <FormattedMessage
          defaultMessage="Responsible"
          description="EmployeeRoleEdit: Responsible title"
        />
      </ListItem.Title>
    </ListItem>
  );
}
